import { useTranslation } from 'react-i18next';
import AttrLabel from '../Components/AttrLabel';
import PanelSection from '../Components/PanelSection';
import AttrField from '../Fields/AttrField';
import BorderFields from '../Fields/BorderFields';
import ColorField from '../Fields/ColorField';
import FileField from '@SidePanel/Fields/FileField';

// TODO: Background Image
function SectionPanel() {
    const { t } = useTranslation();

    return (
        <>
            <PanelSection label={t('Background')} defaultExpanded>
                <AttrLabel>{t('Background Image')}</AttrLabel>
                <AttrField
                    name="style.backgroundImage"
                    Component={FileField}
                    sx={{ height: 100 }}
                    backgroundImage
                />
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholder={t('Transparent')}
                />
            </PanelSection>
            <PanelSection label={t('Border')}>
                <BorderFields
                    property="attributes.style"
                    disableRaduis={false}
                />
            </PanelSection>
        </>
    );
}

export default SectionPanel;
